/**
 * GiftProductDetailPresenter
 * --
 */
import React from 'react';

const GiftProductDetailPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <div>
      <p>GiftProductDetailPresenter</p>
    </div>
  );
};

export default GiftProductDetailPresenter;
